"use strict";
import {http} from '../../core';
import Config from "../../app.config"

// const RequestService = http.create({ baseURL:Config.ssoService});
const RequestServices= http.create()
const RequestServiceUpload=http.create({ baseURL:Config.BASE_API})
const RequestService = http.create({ baseURL:Config.roleUrl});
const RequestUser=http.create({baseURL:Config.ssoServiceUser})
const RequestbaseURL = http.create({baseURL:Config.BASEURL});

export default {
    //获取所有用户信息，查表兑换用
    getUserInfo(params){
        return RequestbaseURL.get('itsm/v2/organization/user/list',params)
    },
    // 用户列表
    getUserList:function (params) {
        return RequestService.get('sys/user/list', params);
    },
    // 新建用户
    addUser:function (params) {
        return RequestService.post('sys/user/save', params);
    },
    //修改用户
    updateUser:function (params) {
        return RequestService.post('sys/user/update', params);
    },
    // 删除用户
    deleteUser:function (params) {
        return RequestService.post('sys/user/delete',params);
    },
    // 重置密码
    resetUserPassword:function (params) {
        return RequestService.get('sys/user/resetPass'+"/"+params.userId)
    },
    // 获取项目的所有角色---下拉框
    getRoleList:function ( params ) {
        return RequestService.get("sys/role/select",params);
    },

    // 角色列表
    getRoleListPage:function (params) {
        return RequestService.get('sys/role/list', params);
    },

    // 删除角色
    deleteRole:function (params) {

    },
    //获取图标列表
    getIconList(params){
        return RequestServices.post('icon/list',params)
    },
    //新建图标
    addIcon(params){
        return RequestServices.post('icon/add',params)
    },
    //删除图标
    deleteIcon(params){
        return RequestServices.get('icon/del',params)
    },
    //第三方用户新增
    addThirdPartyUser(params){
        return RequestServiceUpload.post('usercenter/sso/operator/www/v1/thirdparty/user/add',params)
    },
    //第三方用户编辑
    updateThirdPartyUser(params){
        return RequestServiceUpload.post('usercenter/sso/operator/www/v1/thirdparty/user/update',params)
    },
    //第三方用户列表
    getThirdPartyUserList(params){
        return RequestServiceUpload.post('usercenter/sso/operator/www/v1/thirdparty/user/list',params)
    },
    //第三方用户详情
    getThirdPartyUserDetail(params){
     return RequestServiceUpload.get('usercenter/sso/operator/www/v1/thirdparty/user/detail',params)
    },
    //第三方用户删除
    deleteThirdPartyUser(params){
        return RequestServiceUpload.get('usercenter/sso/operator/www/v1/thirdparty/user/delete',params)
    },
    //在线用户列表
    getOnlineUsersList(params){
        return RequestServices.get('home/online',params)
    },
    //在线用户强制下线
    forceOffline(params){
        return RequestUser.get('user/offline',params)
    },
    //在线用户详细查看
    getOnlineUsersDetail(params){
        return RequestServices.post('organization/user/online_detail',params)
    },
    //数据字典可编辑类型
    getDataDictionariesEdit(params){
        return RequestServices.get('data/data_dict_type',params)
    },
    //关联二线下拉框数据
    getRelatedList(params){
        return RequestServices.get('personnel',params)
    },
    //ONES项目列表
    getOnesProject(params){
        return RequestServices.get('ones/projects',params)
    },
    //选项自定义列表
    getOptionCustomList(params){
        return RequestServices.get('data/list',params)
    },
    //选项自定义新增
    getOptionCustomAdd(params){
        return RequestServices.post('data/add',params)
    },
    //选项自定义更新
    getOptionCustomEdit(params){
        return RequestServices.post('data/update',params)
    },
    //选项自定义新增
    getOptionCustomDel(params){
        return RequestServices.post('data/delete',params)
    },
    //ip白名单列表
    getIpList(params){
        return RequestServices.get('ip_whitelist/list',params)
    },
    getIpWhiteAdd(params){
        return RequestServices.post('ip_whitelist/add',params)
    },
    getIpWhiteEdit(params){
        return RequestServices.post('ip_whitelist/edit',params)
    },
    getIpWhiteDel(params){
        return RequestServices.post('ip_whitelist/delete',params)
    },
}
